var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back"},[_c('img',{staticClass:"pointer",attrs:{"src":require("@/assets/thdImg/pages/back.svg"),"alt":""},on:{"click":function($event){return _vm.handleBack()}}}),_c('span',{staticClass:"back_name"},[_vm._v(_vm._s(_vm.activityData.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }